
import Vue from 'vue'
import debounceDirective from '~/utils/directives/debounce'
export default Vue.extend({
  name: 'ZTextarea',
  directives: {
    debounce: debounceDirective
  },
  props: {
    value: {
      default: '',
      type: String
    },
    placeholder: {
      default: '',
      type: String
    },
    textSize: {
      type: String,
      default: 'xs'
    },
    textColor: {
      type: String,
      default: 'vanilla-400'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    resizable: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: null,
      required: false
    },
    debounceDelay: {
      default: 350,
      type: Number
    },
    backgroundClass: {
      type: String,
      default: 'bg-transparent'
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },

  methods: {
    updateSelf(event: Event): void {
      if (!this.disabled) {
        this.$emit('input', (event.target as HTMLInputElement).value)
      }
    },
    updateDebounce(value: unknown): void {
      this.$emit('debounce-input', value)
    }
  }
})
